import React from 'react';
import { Modal, Button, Badge } from 'react-bootstrap';

const DayDetailsModal = ({ show, onHide, date, events }) => {
  const formatDate = (dateStr) => {
    // Parse the date string as local date (not UTC)
    const [year, month, day] = dateStr.split('-').map(num => parseInt(num));
    const localDate = new Date(year, month - 1, day);
    
    return localDate.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const formatTime = (dateStr) => {
    return new Date(dateStr).toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const getEventTypeAndColor = (event) => {
    if (event.extendedProps?.type === 'oncall' || event.source === 'pagerduty') {
      return { type: 'On-Call', color: '#f44336' };
    } else if (event.extendedProps?.type === 'pto' || event.source === 'pto') {
      return { type: 'PTO', color: '#2196f3' };
    } else if (event.extendedProps?.type === 'change' || event.source === 'jira') {
      return { type: 'Change Request', color: '#4caf50' };
    }
    return { type: 'Event', color: '#6c757d' };
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{date && formatDate(date)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {events.length === 0 ? (
          <p className="text-muted">No events scheduled for this day.</p>
        ) : (
          <div className="list-group">
            {events.map((event, index) => {
              const { type, color } = getEventTypeAndColor(event);
              return (
                <div key={index} className="list-group-item">
                  <div className="d-flex w-100 justify-content-between align-items-start">
                    <div>
                      <h6 className="mb-1">
                        <Badge style={{backgroundColor: color}} className="me-2">{type}</Badge>
                        {event.title}
                      </h6>
                      {event.allDay ? (
                        <p className="mb-1 text-muted">All day event</p>
                      ) : (
                        <p className="mb-1 text-muted">
                          {formatTime(event.start)} - {formatTime(event.end || event.start)}
                        </p>
                      )}
                      {event.extendedProps?.description && (
                        <p className="mb-0 small">{event.extendedProps.description}</p>
                      )}
                      {event.extendedProps?.url && (
                        <a 
                          href={event.extendedProps.url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="small"
                        >
                          View in {type === 'On-Call' ? 'PagerDuty' : type === 'Change Request' ? 'Jira' : 'Calendar'}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DayDetailsModal;